import * as React from "react"
import SubHeaderBenchmark from "./components/SubHeaderBenchmark"
import TabsBenchmark from "./components/TabsBenchmark"

import { Interval } from "components/Shared/PhronesisCalendar/PhronesisCalendar.domain"
import { Tuple } from "components/Shared/Interfaces"
import {
	DEFAULT_DATE_INTERVAL,
	FilterLevelSelected,
	INTIAL_PARAMS,
	LEVEL_NAME_DEFAULT,
	LevelName,
} from "./Benchmark.constant"

import "./Benchmark.styles.scss"

const Benchmark: React.FC = () => {
	const [period, setPeriod] = React.useState<string>(INTIAL_PARAMS.interval)
	const [dateInterval, setDateInterval] = React.useState(DEFAULT_DATE_INTERVAL)
	const [levelName, setLevelName] = React.useState<LevelName>(
		LEVEL_NAME_DEFAULT
	)
	const [labelFatherLevelName, setlabelFatherLevelName] = React.useState<
		string
	>("")
	const [filterLevelSelected, setFilterLevelSelected] = React.useState<
		FilterLevelSelected
	>()

	const handleCalendarOnsubmit = (dates: Interval, period: string) => {
		setDateInterval(dates)
		setPeriod(period)
	}

	const handleFiltersChange = (
		_: string,
		selectedFilters: Array<Tuple>,
		filterLevelSelected: string
	) => {
		setlabelFatherLevelName(filterLevelSelected)
		setFilterLevelSelected({
			filterLevelSelected,
			selectedFilters,
		})
	}

	return (
		<div className="transactional submodule">
			<SubHeaderBenchmark
				onChangeCalendar={handleCalendarOnsubmit}
				onChangeSelector={handleFiltersChange}
			/>
			<TabsBenchmark
				period={period}
				dateInterval={dateInterval}
				levelName={levelName}
				onChangeLevelName={setLevelName}
				labelFatherLevelName={labelFatherLevelName}
				filterLevelSelected={filterLevelSelected}
			/>
		</div>
	)
}

export default Benchmark
